import React from "react";
import moment from "moment";
import {
  getField,
  deserializeField,
  formatDate,
} from "../../util/DynamicItemUtils";

export default function SupportingDocumentation({ item }: any) {
  var dateParsingFormat = "YYYY-MM-DDTHH:mm:ssZ";
  var dateDisplayFormat =
    getField(item, "releasedate") && formatDate(getField(item, "releasedate"));

  const nameData = getField(item, "name") && deserializeField(item, "name")[0];

  return (
    <div>
      <p className="lead-text-lt">Docket Document</p>
      <h3>
        {nameData ? (
          <a href={nameData.mediaUrl} target="_blank">
            {getField(item, "title")}
          </a>
        ) : (
          <div>{getField(item, "title")}</div>
        )}
      </h3>
      <div className="hawk-row inline">
        {getField(item, "docketdocumenttypes") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Docket Document Type</div>
            <div className="lead-text-st">
              {getField(item, "docketdocumenttypes")}
            </div>
          </div>
        )}
        {getField(item, "docket") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Docket</div>
            <div className="lead-text-st">
              {deserializeField(item, "docket")[0].title}
            </div>
          </div>
        )}
        {getField(item, "releasedate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Date</div>
            <div className="lead-text-st">
              {getField(item, "releasedate")
                ? moment(
                    getField(item, "releasedate"),
                    dateParsingFormat
                  ).format(dateDisplayFormat)
                : null}
            </div>
          </div>
        )}
      </div>
      {getField(item, "name") && (
        <a
          href={deserializeField(item, "name")[0].mediaUrl}
          className="hawk-download-pdf"
          download
          target="_blank"
        >
          Download PDF
        </a>
      )}
    </div>
  );
}
